<div
  class="avatar-badges-host"
  [ngClass]="size !== 'default' ? size : ''"
  [style.background-image]="backgroundImageUrl">

  @if (badges.length > 0) {
    <span class="avatar-badges-wrapper">
      @for (badge of badges; track badge; let isFirst = $first) {
        <span
          [title]="badgeTitles"
          class="avatar-badge"
          [ngClass]="badge.cssClass">
        </span>
      }
    </span>
  }
</div>
